/* eslint-disable no-param-reassign,import/named,import/no-cycle */
import { createSlice } from '@reduxjs/toolkit';
import undoable from 'redux-undo';
import {
  ILotLine,
  ILotState, TLotType,
} from '../../../../share/types';
import { LOT_REDO, LOT_UNDO } from '../../constants';
import { batchGroupBy } from '../../../../share/utils/general/groupBy';
import { addLineVertexAction, setLineLengthAction } from './actions';
import { IPoint } from '../../../../share/types/ark1.0/types';
import { LOT } from '../../../../share/constants';

const initialState: ILotState = {
  lotName: '',
  lotArea: 0,
  lotType: 'ENTIRE_BLOCK',
  lotWidth: 0,
  lotHeight: 0,
  polygon: [],
  officialArea: 0,
  lotLines: [],
  topLeftPoint: { x: 0, y: 0 },
  isLoading: false,
  isError: false,
};

const updateLotLines = (slice: ILotState, { payload }: { payload: { lotLines: ILotLine[], polygon: IPoint[] } }) => {
  slice.lotLines = payload.lotLines;
  slice.polygon = payload.polygon;
  slice.lotType = LOT.TYPES.IRREGULAR as TLotType;
};

const lotSlice = createSlice({
  name: 'lot',
  initialState,
  reducers: {
    setLotParameter(slice, { payload }: { payload: { key: keyof ILotState, value: ILotState[keyof ILotState] } }) {
      const { key, value } = payload;
      return {
        ...slice,
        [key]: value,
      };
    },
    setLotWidthAction(slice, { payload }: { payload: number }) {
      return ({
        ...slice,
        lotWidth: payload,
      });
    },
    setLotHeightAction(slice, { payload }: { payload: number }) {
      return ({
        ...slice,
        lotHeight: payload,
      });
    },
    setLotParameters(slice, { payload }: { payload: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [key: keyof ILotState]: ILotState[keyof ILotState] } }) {
      return {
        ...slice,
        ...payload,
      };
    },
    setLotTypeAction(slice, { payload }: { payload: TLotType }) {
      slice.lotType = payload;
    },
    resetLotState(slice) {
      return ({
        ...slice,
        lotName: '',
        lotArea: 0,
        lotType: 'ENTIRE_BLOCK',
        lotWidth: 0,
        lotHeight: 0,
        polygon: [],
        officialArea: 0,
        lotLines: [],
        topLeftPoint: { x: 0, y: 0 },
        isLoading: false,
        isError: false,
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setLineLengthAction.fulfilled, updateLotLines)
      .addCase(addLineVertexAction.fulfilled, updateLotLines);
  },
});

export const undoLotAction = () => ({ type: LOT_UNDO });
export const redoLotAction = () => ({ type: LOT_REDO });
export const {
  setLotParameter,
  setLotParameters,
  setLotWidthAction,
  setLotHeightAction,
  setLotTypeAction,
  resetLotState,
} = lotSlice.actions;

export const lotReducer = undoable(lotSlice.reducer, {
  limit: 10,
  undoType: LOT_UNDO,
  redoType: LOT_REDO,
  groupBy: batchGroupBy.init([] as any),
  // filter: combineFilters(excludeAction(['setLotTypeAction'])),
});
